// Load Bootstrap JS
import { Alert } from 'bootstrap'
import { Collapse } from 'bootstrap'

// Load Styles
import '../scss/main.scss';

/*
 *
 *  Alerts
 *
 *
 */
function setIconsColors() {
    let alertList = document.querySelectorAll('.alert');
    alertList.forEach((alert) => {
        let style = window.getComputedStyle(alert),
            borderColor = style.getPropertyValue('border-bottom-color');
        alert.setAttribute('style', `--icon-color:${borderColor}`);
    });
}
setIconsColors();



/*
 *
 *  Inputs
 *
 *
 */

const inputsList = document.querySelectorAll('.input-group-search, .input-group-cancelable, .input-group-password, .form-control[type="file"]'),
      events = ['focusin', 'focusout', 'keyup', 'input', 'change']

inputsList.forEach((input) => {
    for  (let event of events) {
        input.addEventListener(event, () => {
            handleTypeEvent(input, event)
        })
    }

    let clearIcon = input.querySelector('.icon.cancel')
    
    if (clearIcon) {
        clearIcon.addEventListener('click', () => {
            clearInputValue(input)
        })
    }
})

// Toggle between classes depending on the event
const handleTypeEvent = function (input, event) {
    
    const inputElement = input.querySelector('.form-control')
    
    switch (event) {
        case 'focusin': 
            input.classList.add('-focus')
            inputElement?.classList.add('-focus')
            break
        case 'focusout': 
            input.classList.remove('-focus')
            inputElement?.classList.remove('-focus')
            break
        default : {

            if (inputElement && inputElement.type === 'text') {
                
                let inputValue = inputElement.value.trim()

                if (inputValue) {
                    input.classList.add('-not-empty')
                    inputElement?.classList.add('-not-empty')
                } else {
                    input.classList.remove('-not-empty')
                    inputElement?.classList.remove('-not-empty')
                }
            }
            
            if (input && input.type === 'file') {
                
                let inputValue = input.value.trim()

                if (inputValue) {
                    input.classList.add('-not-empty')
                } else {
                    input.classList.remove('-not-empty')
                }
            }
        }
    }
}

// Clean the input field when you click the x icon
const clearInputValue = function (input) {
    let fieldToClear = input.querySelector('.form-control')
    fieldToClear.value = ''
    input.classList.remove('-not-empty')
}

const inputPasswords = document.querySelectorAll('.input-group-password')
inputPasswords.forEach(password => {
    const eyeIcons = password.querySelectorAll('.icon')
    for (let icon of eyeIcons) {
        icon.addEventListener('click', () => {
            togglePasswordVisibility(password)
        })
    }
})

//Toggle password visibility
const togglePasswordVisibility = function (password) {
    password.classList.toggle('-visible')

    let passwordText = password.querySelector('.form-control')
    passwordText.type === 'password'
        ? passwordText.type = 'text'
        : passwordText.type = 'password'
}

// Must expose the librarie as a global class and than use it in the code.
window.bsCollapse = Collapse;
window.SetIconsColors = setIconsColors;